import { useReducer } from "react";

import ShelfContext from "./shelf-context";

// const red_colour = "rgb(255,1,7)";
// const green_colour = "rgb(37,133,1)";
// const blue_colour = "rgb(1, 1, 255)";
// const amber_colour = "rgb(255, 137, 1)";

// const book_colours = [red_colour, green_colour, blue_colour, amber_colour];

const defaultShelfState = {
  books: [],
};

// context for book shelf
const shelfReducer = (state, action) => {
  if (action.type === "ADD") {
    console.log("----------------running add book");

    var updated_books = state.books.concat(action.book);

    console.log("updated books", updated_books);

    return {
      books: updated_books,
    };
  }

  // remove book from shelf
  if(action.type === "DELETE"){
    var updated_books = state.books.filter((book) => book.id!==action.id)
    return {
      books: updated_books,
    };
  }

  // save shelf state to local storage
  if (action.type === "SAVE") {
    localStorage.setItem("books", JSON.stringify(state.books));

    return {
      books: state.books,
    };
  }
};

const ShelfProvider = (props) => {
  const books = JSON.parse(localStorage.getItem("books"));

  if (books) {
    defaultShelfState.books = books;
  }

  const [shelfState, dispatchShelfAction] = useReducer(
    shelfReducer,
    defaultShelfState
  );

  const addBookHandler = (book) => {
    dispatchShelfAction({ type: "ADD", book: book });
    dispatchShelfAction({ type: "SAVE" });
  };

  const deleteBookHandler = (id) => {
    dispatchShelfAction({type: "DELETE", id:id});
  }

  const saveBooksHandler = () => {
    dispatchShelfAction({ type: "SAVE" });
  };



  const shelfContext = {
    books: shelfState.books,
    addBook: addBookHandler,
    saveBooks: saveBooksHandler,
    deleteBook: deleteBookHandler,
  };

  return (
    <ShelfContext.Provider value={shelfContext}>
      {props.children}
    </ShelfContext.Provider>
  );
};

export default ShelfProvider;
